import CreateProfileModal, {
  CreateProfileModalProps,
} from './CreateProfileModal';

export default CreateProfileModal;
export { CreateProfileModalProps };
